/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/custom_attribute_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/custom_attribute_remote_lookup_provider.rb) */
export const itemTypeSchema = z.strictObject({
  indexed_name: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  type: z.enum(["Array", "Boolean", "Nil", "Number", "Object", "Object Array", "String", "Time"]),
  is_blocklisted: z.boolean(),
  is_deleted: z.boolean(),
  status: z.enum(["active", "blocklisted", "blocklisting", "deleted", "deleting"]),
  internal_id: common.objectId,
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/custom_attribute_remote_lookup_provider.rb) */
export const itemTypeOutputSchema = z.object({
  indexed_name: z.string(),
  name: z.string(),
  description: z.string(),
  type: z.enum(["Array", "Boolean", "Nil", "Number", "Object", "Object Array", "String", "Time"]),
  is_blocklisted: z.boolean(),
  is_deleted: z.boolean(),
  status: z.enum(["active", "blocklisted", "blocklisting", "deleted", "deleting"]),
  internal_id: common.objectId,
});
